module.exports = __webpack_public_path__ + "tripadvisor-src-icon.png?8ea754918f952fd7970eee6326e854b4";